<ng-progress></ng-progress>
<app-sidenav></app-sidenav>
<app-bottom-nav *ngIf="!navData.hasBackButton && !isMerchant"></app-bottom-nav>
